import { getActiveMenuItem } from 'layout/util'
import { useRouter } from 'hooks/useRouter'
import { useMemo } from 'react'

const useActivePage = () => {
  const { pathname } = useRouter()
  const activeMenuItem = useMemo(() => getActiveMenuItem({ pathname }), [pathname])

  return { activeMenuItem }
}

export default useActivePage
